/*
 * The one genuinely round element in the system, and only because a rotating
 * rectangle reads as a glitch rather than as work in progress. Inherits
 * `currentColor` so it takes the tone of whatever control it sits in.
 */
export function Spinner({ className = 'size-5' }: { className?: string }) {
  return (
    <svg className={`animate-spin ${className}`} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.22" strokeWidth="2.6" />
      <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" />
    </svg>
  )
}
